import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import PointCauseSaveContainer from '../../containers/point/PointCauseSaveContainer';
import { POINT_PAGE_NAME } from '../../constants/service/app/pointConstants';

const PointCauseCreate = () => {
  return (
    <PageTemplate pageName={POINT_PAGE_NAME.POINT_CAUSE_CREATE}>
      <PointCauseSaveContainer />
    </PageTemplate>
  );
};

export default PointCauseCreate;
